import { render, staticRenderFns } from "./ChangelogItem.vue?vue&type=template&id=6874fa20&"
import script from "./ChangelogItem.vue?vue&type=script&lang=js&"
export * from "./ChangelogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports